import React, { useCallback, useState } from 'react';

export const useUserAgreement = (onAgree: () => void) => {
  const [hasReadAgreement, setHasReadAgreement] = useState(false);
  const [hasAgreedToAgreement, setHasAgreedToAgreement] = useState(false);
  const [shouldShowPromptMessage, setShouldShowPromptMessage] = useState(false);

  const onScrollBottomOfAgreement = useCallback(() => {
    setHasReadAgreement(true);
    setShouldShowPromptMessage(false);
  }, []);

  const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked && !hasReadAgreement) {
      setShouldShowPromptMessage(true);
    } else if (e.target.checked && hasReadAgreement) {
      setShouldShowPromptMessage(false);
      setHasAgreedToAgreement(e.target.checked);
      onAgree();
    } else {
      setHasAgreedToAgreement(e.target.checked);
    }
  };

  const resetAgreement = () => {
    setHasAgreedToAgreement(false);
  };

  return {
    hasAgreedToAgreement,
    shouldShowPromptMessage,
    onScrollBottomOfAgreement,
    onCheckboxChange,
    resetAgreement,
  };
};
